import api from "../../utils/api/api.utils";
export var getCount = function (countBase) {
    return api.get(countBase);
};
